// extracted by mini-css-extract-plugin
export default {"root":"IconTrashBin_root__SSbqP"};